var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":_vm.type,"disabled":_vm.disabled}},[(_vm.isLoading)?_c('fa',{staticClass:"mr-1",attrs:{"icon":"spinner","spin":""}}):(_vm.icon)?_c('fa',{staticClass:"mr-1",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }